import { Mappable } from "../../../_shared/mappable.class";
import { Event } from '../Event'
import { PledgePerWinTeam } from './PledgePerWinTeam'
import { PledgePerWinPricingTier } from "./PledgePerWinPricingTier";
import { OrderTotals } from "../OrderTotals";

export class PledgePerWin extends Mappable<PledgePerWin> {
    pledgePerWinId: number;
    event: Event;
    teamId: number;
    team: PledgePerWinTeam;
    statistic: string;
    pledgePerWinPricingTiers: PledgePerWinPricingTier[];
    newSubscriberEmailMessage: string;
    gameOverEmailMessage: string;
    subscriptionChargeEmailMessage: string;
    gameOverTextMessage: string;
    subscriptionChargeTextMessage: string;
    sortOrder: number;
    customCheckoutCopy: string;
    orderTotals: OrderTotals;
    //website: PledgePerWinWebsite;
}